import { byteToKilobyte, byteToMegabyte } from 'Helpers'
import { BYTES_IN_MEGABYTE } from 'Constants/Global'

export const getActualSize = (bite: number) => {
	if (bite < BYTES_IN_MEGABYTE) return `${byteToKilobyte(bite)} КБ`
	return `${byteToMegabyte(bite)} МБ`
}

export const formatDate = (data: number | string) => {
	const date = new Date(data)
	const options: Intl.DateTimeFormatOptions = {
		year: 'numeric',
		month: 'numeric',
		day: 'numeric',
	}

	return date.toLocaleDateString('ru', options)
}

export const formatDateAndTime = (data: number | string) => {
	const date = new Date(data)
	const options: Intl.DateTimeFormatOptions = {
		year: 'numeric',
		month: 'numeric',
		day: 'numeric',
		hour: 'numeric',
		minute: 'numeric',
		second: 'numeric',
	}

	return date.toLocaleDateString('ru', options)
}

export const getFileNameAndExt = (fullName: string) => {
	const nameToArray = fullName.split('.')
	const ext = nameToArray.pop()

	return {
		fileName: nameToArray.join('.'),
		ext,
	}
}

export const downloadFileFromApi = (file: Blob, title: string) => {
	const link = document.createElement('a')
	link.href = URL.createObjectURL(file)
	link.download = title
	link.click()
	URL.revokeObjectURL(link.href)
}

export const formatDateForNewUpload = (data: number | string) => {
	const date = new Date(data)
	const options: Intl.DateTimeFormatOptions = {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
		hour: 'numeric',
		minute: 'numeric',
	}

	return date.toLocaleDateString('ru', options).replaceAll('.', '').replace(' г', '')
}
